import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M12.57 6.637H3.429c-.631 0-1.143.492-1.143 1.1v6.592c0 .607.512 1.1 1.143 1.1h9.143c.631 0 1.143-.493 1.143-1.1V7.736c0-.607-.512-1.099-1.143-1.099Z",
      stroke: "currentColor"
    }
  ),
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M10.823 2.274a4 4 0 0 0-1.292-.84A4.1 4.1 0 0 0 8 1.143c-1.06 0-2.078.405-2.828 1.126A3.77 3.77 0 0 0 4 4.99v1.648m4 4.944a.56.56 0 0 0 .57-.55.56.56 0 0 0-.57-.55.56.56 0 0 0-.572.55c0 .304.256.55.571.55Z",
      stroke: "currentColor"
    }
  )
] });
export {
  s as U
};
